import { useDispatch, useSelector } from "react-redux";
import { setOpen, closeModal } from "./ConfirmModal.slice";

// Mapa de acciones disponibles
const actionHandlers = new Map();

export const useConfirmModal = () => {
  const dispatch = useDispatch();
  const { actionId } = useSelector((state) => state.confirmModal);

  const showConfirmModal = ({
    message,
    actionId,
    title = "Confirmar",
    onConfirm,
  }) => {
    // Registrar la función de confirmación en el mapa
    if (actionId && onConfirm) {
      actionHandlers.set(actionId, onConfirm);
    }

    dispatch(
      setOpen({
        open: true,
        message,
        actionId,
        title,
      })
    );
  };

  const handleConfirm = () => {
    if (actionId && actionHandlers.has(actionId)) {
      const handler = actionHandlers.get(actionId);
      handler();
      actionHandlers.delete(actionId); // Limpiar después de usar
    }

    dispatch(closeModal());
  };

  const handleClose = () => {
    // Limpiar el handler si existe
    if (actionId && actionHandlers.has(actionId)) {
      actionHandlers.delete(actionId);
    }

    dispatch(closeModal());
  };

  return {
    showConfirmModal,
    handleConfirm,
    handleClose,
  };
};
